import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/coastal-dusk.css';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative" style={{ background: '#1a1a1a' }}>
      <div className="landing-orb cool focus-shift" style={{ '--orb-opacity': '0.3', top: '-5%', left: '-5%', width: '45vw', height: '45vw', maxWidth: '500px', maxHeight: '500px' }} />
      <div className="landing-orb neutral" style={{ '--orb-opacity': '0.2', top: '55%', right: '-5%', width: '42vw', height: '42vw', maxWidth: '450px', maxHeight: '450px', animationDelay: '-4s' }} />

      <div className="max-w-2xl mx-auto px-6 sm:px-10 py-20 relative z-10">
        <button
          onClick={() => navigate(-1)}
          className="landing-ghost-link mb-10 block"
          style={{ fontSize: '0.82rem' }}
          data-testid="back-btn"
        >
          &larr; Back
        </button>

        <h1 className="text-display mb-2" style={{ fontSize: 'clamp(1.4rem, 4vw, 1.8rem)' }}>
          Terms of Service
        </h1>
        <p className="landing-step-body" style={{ color: 'var(--text-secondary)', fontSize: '0.82rem', marginBottom: '48px' }}>
          Effective Date: April 11, 2026 &middot; Last Updated: April 11, 2026<br />
          Operator: EnQUIPs LLC &middot; Contact: info@clarityjournalbyenquips.com
        </p>

        <p className="landing-step-body" style={{ marginBottom: '32px' }}>
          By accessing or using Clarity Soundtrack, you agree to these Terms.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginBottom: '12px' }}>
          What Clarity Soundtrack Is
        </h3>
        <p className="landing-step-body">
          Clarity Soundtrack provides guided prompts, reflective exercises, and meditative frameworks designed 
          to support personal clarity and intentional living. The Services are for personal reflection only — not 
          therapy, counseling, financial advice, legal advice, or medical guidance of any kind. No professional 
          relationship is created between you and EnQUIPs LLC through your use of these Services.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Intellectual Property
        </h3>
        <p className="landing-step-body">
          All content within Clarity Soundtrack — including prompts, language, frameworks, audio, designs, 
          branding, and digital materials — is the exclusive property of EnQUIPs LLC. Your purchase grants a 
          personal, non-transferable, non-exclusive license for individual use only.
        </p>
        <p className="landing-step-body">
          You may not copy, reproduce, distribute, modify, or use the content for any commercial, coaching, 
          consulting, or educational purpose. If you purchase Clarity Soundtrack as a gift, you may transfer this 
          license to the intended recipient. Further redistribution is not permitted.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Eligibility
        </h3>
        <p className="landing-step-body">
          You must be at least 18 years old to purchase or use the Services.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Refund Policy
        </h3>
        <p className="landing-step-body">
          This experience is delivered and made accessible instantly. Because the value cannot be returned or 
          revoked, all sales are final.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          User Responsibilities
        </h3>
        <p className="landing-step-body">
          You agree to use the Services lawfully, respectfully, and in a non-harmful manner. You may not use the 
          Services to violate any laws, harm others, or attempt to access systems or data without authorization.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Limitation of Liability
        </h3>
        <p className="landing-step-body">
          To the fullest extent permitted by law, EnQUIPs LLC is not liable for any indirect, incidental, or 
          consequential damages — including loss of data, financial loss, or decisions you make based on the 
          content. Governing law: State of Illinois.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Modifications
        </h3>
        <p className="landing-step-body">
          We may update the Services or these Terms at any time. Continued use after changes constitutes 
          acceptance of the updated Terms.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
